/** Mobile: 0–599px. Tablet starts at 600. */
export const RESPONSIVE_BREAKPOINT_MOBILE = 600;
/** Tablet: 600–1023px. Desktop starts at 1024. */
export const RESPONSIVE_BREAKPOINT_TABLET = 1024;
/** Desktop: 1024px+ (same as tablet end; use for min-width desktop). */
export const RESPONSIVE_BREAKPOINT_DESKTOP = RESPONSIVE_BREAKPOINT_TABLET;

export const screens = {
  desktop: `${RESPONSIVE_BREAKPOINT_DESKTOP}px`,
  tablet: `${RESPONSIVE_BREAKPOINT_MOBILE}px`,
} as const;
